export default __webpack_public_path__ + "static/media/db_mail_icon.fd7ff7e5.svg";